<template>
	<div class=" statisticalAnalysis">
		<leftnav class="fl" mkcode="E" itemcode="E-TJFX"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader :show-video="true" :video-type="5"></govheader>
			<div class="index_left_centerpage">
				<div v-if="userdata.token">
					
				<!-- 选择开始 -->
				<div class="stastican_screen">
					<el-select v-model="modeval" placeholder="视图管理" @change="viewtoggle">
						<el-option v-for="item in defaultviewoption" :key="item.value" :label="item.label"
							:value="item.label"></el-option>
					</el-select>
					<el-select v-model="gsvalue" placeholder="全部" v-show="usertype == 2" @change="selectGet"><el-option
							v-for="item in gsoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<el-date-picker v-model="timevalue" type="daterange" range-separator="至" start-placeholder="开始日期"
						:picker-options="pickerOptions" end-placeholder="结束日期"
						@change="getworkcount(timevalue)"></el-date-picker><span class="chose_empty bluefont"
						@click="empty">清空</span>
				</div>
				<!-- 选择结束 -->
				<!-- 总体统计开始 -->
				<div class="all_statistics whitebox">
					<h3>总体统计</h3>
					<ul>
						<li>
							<dl>
								<dt>关注企业</dt>
								<dd>{{ worklist.collectEnterprise }}</dd>
							</dl>
						</li>
						<li class="statistics_list">
							<dl>
								<dt>关注园区</dt>
								<dd>{{ worklist.collectPark }}</dd>
							</dl>
						</li>
						<li class="statistics_list">
							<dl>
								<dt>跟进企业</dt>
								<dd>{{ worklist.trackEnterprise }}</dd>
							</dl>
						</li>
						<li class="statistics_list">
							<dl>
								<dt>新增联系人</dt>
								<dd>{{ worklist.addContact }}</dd>
							</dl>
						</li>
						<li class="statistics_list">
							<dl>
								<dt>意向企业</dt>
								<dd>{{ worklist.purposeEnterprise }}</dd>
							</dl>
						</li>
						<li class="statistics_list">
							<dl>
								<dt>已签约</dt>
								<dd>{{ worklist.alreadySignied }}<span class="percentage">
										<!-- （0%） -->
									</span></dd>
							</dl>
						</li>
						<li class="statistics_list">
							<dl>
								<dt>已落地</dt>
								<dd>{{ worklist.alreadyComplete }}<span class="percentage">
										<!-- （0%） -->
									</span></dd>
							</dl>
						</li>
					</ul>
				</div>
				<!-- 个人视图 -->
				<!-- 总体统计结束 -->
				<!-- 部门数据开始 -->
				<div class="department_data_big flexcss">
					<div class="department_data whitebox " v-show="modevalid == 2">
						<h3>部门数据</h3>
						<div class="enterprise_list_box">
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
								<tr>
									<th>所属部门</th>
									<th>姓名</th>
									<th>关注企业</th>
									<th>关注园区</th>
									<th>新增联系人</th>
									<th>跟进企业</th>
									<th>意向企业</th>
									<th>已签约</th>
									<th>已落地</th>
								</tr>
								<tr v-for="(item,i) in ndepartmentdata" :key="i" >
									<td>{{ item.departmentName }}</td>
									<td>{{ item.userName }}</td>
									<td>{{ item.collectEnterprise }}</td>
									<td>{{ item.collectPark }}</td>
									<td>{{ item.addContact }}</td>
									<td>{{ item.trackEnterprise }}</td>
									<td>{{ item.purposeEnterprise }}</td>
									<td>{{ item.alreadySignied }}</td>
									<td>{{ item.alreadyComplete }}</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="department_data whitebox " style="width: 100%;" v-show="modevalid == 1">
						<h3>个人数据</h3>
						<div class="enterprise_list_box">
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
								<tr>
									<th>录入时间</th>
									<th>企业名称</th>
									<th>联系人</th>
									<th>跟进状态</th>
									<th>跟进次数</th>
									<th>最后跟进时间</th>
									<th>备注</th>
								</tr>
								<tr v-for="item in cuslist" :key="item.id">
									<td>{{ item.enterTime }}</td>
									<td class="workbench_enterprise_details"
										@click="detailrouterto('/workbenchEnterpriseDetails', item.id)">
										{{ item.companyName }}</td>
									<td>
										<!-- <span  v-for="(list,i) in item.contactList" v-show="i<1">{{list.contactName}}</span> <span v-show="item.contactList.length==0">暂无</span>--><span
											v-for="(list, i) in item.contactList" :key="i"
											v-show="i < 1"><em>{{ list.contactName }}</em></span>
									</td>
									<td>
										<span v-show="item.trackStatus == 0">-</span>
										<span v-if="item.trackStatus == 1">初访{{ item.trackStatus }}</span>
										<span v-if="item.trackStatus == 2">有意向{{ item.trackStatus }}</span>
										<span v-if="item.trackStatus == 3">已签约{{ item.trackStatus }}</span>
										<span v-if="item.trackStatus == 4">已落地{{ item.trackStatus }}</span>
										<span v-if="item.trackStatus == 5">暂时搁置{{ item.trackStatus }}</span>
									</td>
									<td>0</td>
									<td>
										<span v-show="item.trackTime != 0">{{ item.trackTime }}</span>
										<span v-show="item.trackTime == 0">-</span>
									</td>
									<td>
										<span v-if="item.remark != 0">{{ item.remark }}</span>
										<span v-if="item.remark == 0">无</span>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="focusenterprises_gov whitebox  " v-if="modevalid == 2">
						<select class="proselect" v-model="sid" @change="chartFun('chart', chartdata1);">
							<option v-for="(item, i) in state" :value="item.sid" :key="i">{{ item.value }}</option>
						</select>
						<div id="chart"></div>
					</div>
					<!-- <div class="focusenterprises_gov whitebox" v-show="usertype==1">
					<h3>关注企业</h3>
				<div id="chart2"></div>
				</div> -->
				</div>
				<!-- 部门数据结束 -->
			
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'statisticalAnalysis',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			title: "统计分析",
			gsoptions: [{
				value: '选项1',
				label: '全部'
			}, {
				value: '选项2',
				label: '招商部'
			}, {
				value: '选项3',
				label: '招商部'
			}, {
				value: '选项4',
				label: '招商部'
			}, {
				value: '选项5',
				label: '招商部'
			}],
			defaultviewoption: [{
				value: '1',
				label: '个人视图'
			}],
			sid: 1,
			state: [{
				sid: 1,
				value: '关注企业'
			}, {
				sid: 2,
				value: '关注园区'
			}, {
				sid: 3,
				value: '跟进企业'
			}, {
				sid: 4,
				value: '新增联系人'
			}, {
				sid: 5,
				value: '意向企业'
			}, {
				sid: 6,
				value: '已签约'
			}, {
				sid: 7,
				value: '已落地'
			},],
			modeval: '视图', //视图
			modevalid: 2,
			gsvalue: '全部', //部门value
			timevalue: '', //日期选择value
			value1: '',
			systemdata: [],
			chartdata1: [],
			usertype: 2,
			worklist: {}, //工作台工作统计列表管理员视图
			worklist1: {}, //工作台工作统计列表个人视图
			departmentdata: [], //工作台部门数据列表
			ndepartmentdata: [], //工作台部门数据列表
			tracklist: [], //个人视图跟进列表
			cuslist: [], //客户列表
			crmuserdata: [],
			pickerOptions: {
				onPick: ({ maxDate, minDate }) => {
					this.pickerMinDate = minDate.getTime()
					if (maxDate) {
						this.pickerMinDate = ''
					}
				},
				// 限制不能选择今天之后的日期
				disabledDate: (time) => {
					if (this.pickerMinDate !== '') {
						let one = 31 * 24 * 3600 * 1000
						let minTime = this.pickerMinDate - one
						let maxTime = this.pickerMinDate + one
						if (maxTime > new Date()) {
							maxTime = new Date()
						}
						return time.getTime() < minTime || time.getTime() > maxTime
					}
					return time.getTime() > Date.now()
				},
			},
		}
	},
	// watch: { //深度 watcher 列表是否所有选中，选中则全选按钮勾选
	// 	'modeval': {
	// 		handler(val, oldVal) {
	// 			console.log(val);
	// 			if (val == 1) {
	// 				this.usertype = 1;
	// 				this.getworkcount('', 1);
	// 				// setTimeout(()=>{
	// 				//   this.chartFun2('chart2',this.cuslist);
	// 				// },500)
	// 			} else {
	// 				this.usertype = 2;
	// 				setTimeout(() => {
	// 					this.chartFun('chart', this.chartdata1); //不知道为啥$nextTick没用就用了定时器，不用的话图不能实时获取盒子高度
	// 				}, 500)
	// 			}
	// 			this.getworkcount('', val);
	// 		},
	// 		deep: true
	// 	}
	// },
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		this.userdata = this.getuseriformation();
		if(this.userdata.token){
			this.crmlogin();

		}
	},
	methods: {
		//切换视图
		viewtoggle(value) {
			console.log('viewtoggle', value)
			if (value == '管理视图') {
				this.modevalid = 2;
			} else {
				this.modevalid = 1;
			}
			this.getworkcount();
		},
		//crm 用户登录权限
		crmlogin() {
			this.crmuserdata = this.userdata.crmInfor;
			if (this.crmuserdata.roleType < 3) {
				this.defaultviewoption.unshift({
					value: '2',
					label: '管理视图'
				});
				this.modeval = '管理视图';
				this.modevalid = 2;
			} else {
				this.usertype = 1;
				this.modeval = '个人视图';
				this.modevalid = 1;
			};
			console.log(this.defaultviewoption, this.crmuserdata.roleType)
			this.getworkcount();
			this.gettracklist();
			this.getdepartmentlist();
		},
		//总体统计
		getworkcount(date) {
			var _this = this, zhtime = '';
			var viewMode = this.modevalid;
			console.log('总体统计', this.modevalid)
			// console.log(date, viewMode);
			if (date) {
				var time1 = _this.dateFormat(date[0]);
				var time2 = _this.dateFormat(date[1]);
				zhtime = time1 + ',' + time2;
				// console.log(time1, time2, zhtime);
			}
			this.bus.$emit('loading', true);
			var ajaxurl = this.$api.crm.analyse.list() + '?dateRange=' + zhtime + '&viewMode=' + viewMode;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log("工作统计", res.data.data);
				if (res.data.success) {
					console.log(ajaxurl, viewMode == 1);

					if (viewMode == 1) {
						_this.cuslist = res.data.list; //个人数据 
					} else {
						_this.chartdata1 = res.data.list;
						_this.chartFun('chart', _this.chartdata1);
						_this.departmentdata = res.data.list; //部门数据 
						_this.ndepartmentdata = res.data.list;
					}
					_this.worklist = res.data.data;
					// console.log("ajaxcuslit", _this.cuslist);
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		//获取跟进列表
		gettracklist() {
			var _this = this;
			this.$axios.get(this.$api.crm.track.list(), {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("跟进列表", res);
				if (res.data.success) {
					_this.tracklist = res.data.list;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取部门列表
		getdepartmentlist() {
			var _this = this;
			this.$axios.get(this.$api.crm.department.list(), {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("部门列表", res);
				if (res.data.success) {
					_this.gsoptions = res.data.list;
					_this.gsoptions.unshift({
						id: 0,
						name: '全部'
					});
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//企业详情跳转
		detailrouterto(path, id, code) {
			this.routerlinkarry(path, {
				type: 2,
				id: id,
				code: code
			});
		},
		//清空
		empty() {
			this.modeval = '';
			this.gsvalue = '';
			this.timevalue = '';
		},
		//格式化日期 （时间戳）
		dateFormat(date) {
			var M = date.getMonth() + 1;
			M = M < 10 ? ('0' + M) : M;
			var y = date.getFullYear();
			var d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
			var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
			var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
			var time = y + '-' + M + '-' + d;
			var stime = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
			console.log('time', time);
			return time;
		},


		//下拉框选中事件
		selectGet(vId) { //这个vId也就是value值 
			let obj = {};
			obj = this.gsoptions.find((item) => { //这里的userList就是上面遍历的数据源
				return item.id === vId; //筛选出匹配数据
			});
			console.log(obj.name); //我这边的name就是对应label的 
			var dat = [];
			for (var i = 0; i < this.departmentdata.length; i++) {
				if (this.departmentdata[i].departmentName == obj.name) {
					// console.log(this.departmentdata[i]);
					dat.push(this.departmentdata[i]);
				}
			};

			if (obj.name == '全部') {
				this.ndepartmentdata = this.departmentdata;
			} else {
				this.ndepartmentdata = dat;
			}

			this.chartFun('chart', this.ndepartmentdata);
			this.chartdata1 = this.ndepartmentdata;
			// console.log('ndata', this.ndepartmentdata, dat);
		},
		chartFun(el, data) {
			var chart = echarts.init(document.getElementById(el));
			var _this = this,
				xline = [],
				seriesline = [];
			var datalen = data.length - 1;
			for (var i = 0; i < data.length; i++) {
				xline.push(data[i].userName);
				if (this.sid == 1) {
					// console.log(this.sid);
					seriesline.push(data[i].collectEnterprise);
				} else if (this.sid == 2) {
					console.log(this.sid);
					seriesline.push(data[i].collectPark);
				} else if (this.sid == 3) {
					console.log(this.sid);
					seriesline.push(data[i].trackEnterprise);
				} else if (this.sid == 4) {
					console.log(this.sid);
					seriesline.push(data[i].addContact);
				} else if (this.sid == 5) {
					console.log(this.sid);
					seriesline.push(data[i].purposeEnterprise);
				} else if (this.sid == 6) {
					console.log(this.sid);
					seriesline.push(data[i].alreadySignied);
				} else if (this.sid == 7) {
					console.log(this.sid);
					seriesline.push(data[i].alreadyComplete);
				}

			};
			console.log(data, xline, seriesline);
			xline.reverse();
			seriesline.reverse();
			var ddts = xline.length;
			var sheight = 555;
			if (ddts > 9) {
				sheight = 42 + 53 * ddts;
			}
			document.getElementById('chart').style = 'height:' + sheight + 'px';
			var option = {
				title: {
					text: "",
					left: 25,
					top: 20,
					textStyle: {
						color: '#eee',
						fontSize: 16
					}
				},
				tooltip: {
					trigger: 'axis',
				},
				grid: {
					x: 100,
					y: 10,
					x2: 50,
					y2: 40,
					show: true,
					borderWidth: 0,
				},
				label: {
					show: true,
					position: 'right',
					valueAnimation: true,
					color: "#C7C9D0"
				},
				xAxis: {
					type: 'value',
					axisTick: {
						show: false
					},
					boundaryGap: [0, 0.01],
					splitLine: {
						show: false
					},
					axisLabel: {
						formatter: function () {
							return "";
						}
					}
				},
				yAxis: {
					type: 'category',
					splitLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true,
						color: 'red',
						lineStyle: {
							color: '#C7C9D0',
						}
					},
					data: xline,
					axisLabel: {
						fontSize: 14,
						color: '#000'
					}
				},
				series: [{
					data: seriesline,
					type: 'bar',
					barWidth: 40,
					color: '#1890ff',
				}]
			};
			chart.clear();
			chart.setOption(option);
			chart.resize({ height: sheight })
		},
		chartFun2(el, data) {
			console.log('data2', data);
			var chart = echarts.init(document.getElementById(el));
			var _this = this,
				xline = [],
				seriesline = [];
			//添加属性number:次数
			data.forEach(tem => {
				tem.number = 1;
			});
			//去重，并添加次数
			for (var i = 0; i < data.length; i++) {
				for (var j = i + 1; j < data.length; j++) {
					if (data[i].enterTime == data[j].enterTime) {
						data.splice(j, 1);
						j--;
						data[i].number++;
					}
				}
			}
			for (var n = 0; n < data.length; n++) {
				xline.push(data[n].enterTime);
				seriesline.push(data[n].number);
			}
			console.log(data, xline, seriesline,)
			var option = {
				title: {
					text: "",
					left: 25,
					top: 20,
					textStyle: {
						color: '#eee',
						fontSize: 16
					}
				},
				tooltip: {
					trigger: 'axis',
				},
				grid: {
					x: 100,
					y: 10,
					x2: 50,
					y2: 40,
					show: true,
					borderWidth: 0,
				},
				label: {
					show: true,
					position: 'right',
					valueAnimation: true,
					color: "#C7C9D0"
				},
				xAxis: {
					type: 'value',
					axisTick: {
						show: false
					},
					boundaryGap: [0, 0.01],
					splitLine: {
						show: false
					},
					axisLabel: {
						formatter: function () {
							return "";
						}
					}
				},
				yAxis: {
					type: 'category',
					splitLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true,
						color: 'red',
						lineStyle: {
							color: '#C7C9D0',
						}
					},
					data: xline,
					axisLabel: {
						fontSize: 14,
						color: '#000'
					}
				},
				series: [{
					data: seriesline,
					type: 'bar',
					barWidth: 40,
					color: '#1890ff',
				}]
			};
			chart.setOption(option);
		},
	}
}
</script>

<style></style>
